// src/entities/types/index.ts
var AllCurrencyCodes = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "IQD",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MOP",
  "MRU",
  "MUR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLE",
  "SOS",
  "SRD",
  "STN",
  "SZL",
  "THB",
  "TJS",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "USD",
  "UYU",
  "UZS",
  "VES",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZWG",
  "ZMW"
];
var ethnicityToCodeMap = {
  "White British": "01",
  "White Irish": "02",
  "White Other": "03",
  "White and Black Caribbean": "04",
  "White and Black African": "05",
  "White and Asian": "06",
  "Other Mixed Background": "07",
  "Asian or Asian British Indian": "08",
  "Asian or Asian British Pakistani": "09",
  "Asian or Asian British Bangladeshi": "10",
  "Other Asian background": "11",
  "Black or Black British Caribbean": "12",
  "Black or Black British African": "13",
  "Other Black Background": "14",
  Chinese: "15",
  "Any Other Ethnic Group": "16",
  "Patient declined": "99"
};

// src/entities/sms/index.ts
var SmsTemplateKeys = [
  "paymentLinkSms",
  "appointmentRescheduledSms",
  "appointmentCancelledSms",
  "appointmentConfirmedSms"
];

// src/entities/email-templates/variables.ts
var AVAILABLE_EMAIL_VARIABLES = [
  {
    key: "appointmentId",
    label: "Booking ID",
    description: "Appointment Id",
    isFilled: true
  },
  {
    key: "bookingId",
    label: "Booking ID",
    description: "Unique booking identifier",
    isFilled: true
  },
  {
    key: "serviceName",
    label: "Service Name",
    description: "Name of the booked service",
    isFilled: true
  },
  {
    key: "serviceDuration",
    label: "Service Duration",
    description: "Duration of the service",
    isFilled: true
  },
  {
    key: "dateTimeOfAppointment",
    label: "Appointment Date & Time",
    description: "Combined date and time of the appointment",
    isFilled: true
  },
  {
    key: "startDateTimeOfAppointment",
    label: "Starting Date Time Of Appointment",
    description: "Combined date and time of when appointment starts",
    isFilled: true
  },
  {
    key: "endDateTimeOfAppointment",
    label: "Ending Date Time Of Appointment",
    description: "Combined date and time of when appointment ends",
    isFilled: true
  },
  {
    key: "locationAddress",
    label: "Location Address",
    description: "Address of the service location",
    isFilled: true
  },
  {
    key: "locationGMapUrl",
    label: "Google Maps URL",
    description: "Google Maps link for the location",
    isFilled: true
  },
  {
    key: "customerName",
    label: "Customer Name",
    description: "Full name of the customer",
    isFilled: true
  },
  {
    key: "customerEmail",
    label: "Customer Email",
    description: "Customer email address",
    isFilled: true
  },
  {
    key: "customerPhone",
    label: "Customer Phone",
    description: "Customer phone number",
    isFilled: true
  },
  {
    key: "serviceAmount",
    label: "Service Amount",
    description: "Amount charged for the service",
    isFilled: true
  },
  {
    key: "businessLogo",
    label: "Business Logo",
    description: "Logo of the business",
    isFilled: true
  },
  {
    key: "locationPhoneNo",
    label: "Location Phone Number",
    description: "Contact number of the service location",
    isFilled: true
  },
  {
    key: "paymentLink",
    label: "Payment Link",
    description: "Link for payment processing",
    isFilled: true
  },
  {
    key: "businessName",
    label: "Business Name",
    description: "Name of the business",
    isFilled: true
  },
  {
    key: "locationName",
    label: "Location Name",
    description: "Name of the service location",
    isFilled: true
  },
  {
    key: "googleReviewUrl",
    label: "Google Review URL",
    description: "Link to leave a review on Google",
    isFilled: true
  },
  {
    key: "googleIcon",
    label: "Google Icon",
    description: "Icon representing Google Reviews",
    isFilled: true
  },
  {
    key: "trustPilotReviewUrl",
    label: "TrustPilot Review URL",
    description: "Link to leave a review on TrustPilot",
    isFilled: true
  },
  {
    key: "trustPilotIcon",
    label: "TrustPilot Icon",
    description: "Icon representing TrustPilot Reviews",
    isFilled: true
  },
  {
    key: "transactionId",
    label: "Transaction ID",
    description: "Unique ID of the payment transaction",
    isFilled: true
  },
  {
    key: "paymentMethod",
    label: "Payment Method",
    description: "Method used for payment",
    isFilled: true
  },
  {
    key: "paymentDateTime",
    label: "Payment Date & Time",
    description: "Date and time when payment was made",
    isFilled: true
  },
  {
    key: "refundAmount",
    label: "Refund Amount",
    description: "Amount refunded for the payment",
    isFilled: true
  },
  {
    key: "refundDateTime",
    label: "Refund Date & Time",
    description: "Date and time when refund was made",
    isFilled: true
  }
];
var AVAILABLE_EMAIL_VARIABLES_TUPLE = [
  {
    key: "appointmentId",
    label: "Booking ID",
    description: "Appointment Id",
    isFilled: true
  },
  {
    key: "bookingId",
    label: "Booking ID",
    description: "Unique booking identifier",
    isFilled: true
  },
  {
    key: "serviceName",
    label: "Service Name",
    description: "Name of the booked service",
    isFilled: true
  },
  {
    key: "serviceDuration",
    label: "Service Duration",
    description: "Duration of the service",
    isFilled: true
  },
  {
    key: "dateTimeOfAppointment",
    label: "Appointment Date & Time",
    description: "Combined date and time of the appointment",
    isFilled: true
  },
  {
    key: "startDateTimeOfAppointment",
    label: "Starting Date Time Of Appointment",
    description: "Combined date and time of when appointment starts",
    isFilled: true
  },
  {
    key: "endDateTimeOfAppointment",
    label: "Ending Date Time Of Appointment",
    description: "Combined date and time of when appointment ends",
    isFilled: true
  },
  {
    key: "locationAddress",
    label: "Location Address",
    description: "Address of the service location",
    isFilled: true
  },
  {
    key: "locationGMapUrl",
    label: "Google Maps URL",
    description: "Google Maps link for the location",
    isFilled: true
  },
  {
    key: "customerName",
    label: "Customer Name",
    description: "Full name of the customer",
    isFilled: true
  },
  {
    key: "customerEmail",
    label: "Customer Email",
    description: "Customer email address",
    isFilled: true
  },
  {
    key: "customerPhone",
    label: "Customer Phone",
    description: "Customer phone number",
    isFilled: true
  },
  {
    key: "serviceAmount",
    label: "Service Amount",
    description: "Amount charged for the service",
    isFilled: true
  },
  {
    key: "businessLogo",
    label: "Business Logo",
    description: "Logo of the business",
    isFilled: true
  },
  {
    key: "locationPhoneNo",
    label: "Location Phone Number",
    description: "Contact number of the service location",
    isFilled: true
  },
  {
    key: "paymentLink",
    label: "Payment Link",
    description: "Link for payment processing",
    isFilled: true
  },
  {
    key: "businessName",
    label: "Business Name",
    description: "Name of the business",
    isFilled: true
  },
  {
    key: "locationName",
    label: "Location Name",
    description: "Name of the service location",
    isFilled: true
  },
  {
    key: "googleReviewUrl",
    label: "Google Review URL",
    description: "Link to leave a review on Google",
    isFilled: true
  },
  {
    key: "googleIcon",
    label: "Google Icon",
    description: "Icon representing Google Reviews",
    isFilled: true
  },
  {
    key: "trustPilotReviewUrl",
    label: "TrustPilot Review URL",
    description: "Link to leave a review on TrustPilot",
    isFilled: true
  },
  {
    key: "trustPilotIcon",
    label: "TrustPilot Icon",
    description: "Icon representing TrustPilot Reviews",
    isFilled: true
  },
  {
    key: "transactionId",
    label: "Transaction ID",
    description: "Unique ID of the payment transaction",
    isFilled: true
  },
  {
    key: "paymentMethod",
    label: "Payment Method",
    description: "Method used for payment",
    isFilled: true
  },
  {
    key: "paymentDateTime",
    label: "Payment Date & Time",
    description: "Date and time when payment was made",
    isFilled: true
  },
  {
    key: "refundAmount",
    label: "Refund Amount",
    description: "Amount refunded for the payment",
    isFilled: true
  },
  {
    key: "refundDateTime",
    label: "Refund Date & Time",
    description: "Date and time when refund was made",
    isFilled: true
  }
];

// src/entities/email-templates/index.ts
var PlatFormInternalTemplatesConfigs = {
  newBusinessSignUp: {
    file: "new.business.sign.up.html",
    subject: "Action Required: New Business Registered"
  }
};
var EmailTemplatesKeys = [
  "appointmentCancelled",
  "appointmentChanged",
  "appointmentConfirmed",
  //used when confirmed from location admin.
  "appointmentPaymentPending",
  "followUpAppointmentCreation",
  "appointmentReview",
  "paymentReceipt",
  "publicAppointmentCreatedAndPaid",
  "refundIssued",
  "followUpCustomer",
  "appointmentConfirmedWithPaymentReceipt",
  //when appointment is paid from public site
  "newBusinessSignUp"
  //for seamlessideas team when new business signs up.
];
var EmailBadgeValues = [
  "warning",
  "danger",
  "success",
  "info",
  "primary",
  "secondary"
];

// src/entities/features/index.ts
var STARTER_FEATURES = [
  { id: 0, name: "Calendar", code: "calendars" },
  { id: 0, name: "Add/Amend Appointments", code: "add_amend_appointments" },
  { id: 0, name: "Email Notifications", code: "email_notifications" },
  { id: 0, name: "Customer Management", code: "customer_management" },
  { id: 0, name: "Service Management", code: "service_management" },
  { id: 0, name: "Payment Logs", code: "payment_logs" },
  {
    id: 0,
    name: "Customer Reports And Dashboards",
    code: "customer_reports_dashboards"
  },
  {
    id: 0,
    name: "Terms and conditions management",
    code: "terms_conditions_management"
  },
  {
    id: 0,
    name: "Appointment Url access options",
    code: "appointment_url_access"
  },
  {
    id: 0,
    name: "Payment Integration (Square)",
    code: "payment_integration_square"
  }
];
var CORE_FEATURES = [
  {
    id: 1,
    name: "Custom Email Templates",
    code: "email_templates_customization"
  },
  { id: 2, name: "SMS Notifications", code: "sms_notifications" },
  { id: 3, name: "Custom SMS Templates", code: "sms_templates_customization" },
  { id: 4, name: "Refund Management", code: "refund" },
  { id: 5, name: "Custom Cancellation Policy", code: "cancellation_policy" },
  { id: 6, name: "User Management", code: "users_management" },
  { id: 7, name: "Location Management", code: "location_management" },
  { id: 8, name: "Breaks Management", code: "breaks_management" },
  { id: 9, name: "Time Off Management", code: "timeOff_management" },
  {
    id: 10,
    name: "Appointment Scheduling Policies",
    code: "appointment_scheduling_policies"
  },
  { id: 11, name: "Customer Reviews & Ratings", code: "reviews" },
  {
    id: 12,
    name: "Calendar Integration (Google, Outlook, etc.)",
    code: "calendar_integration"
  }
];

// src/entities/payment-providers/stripe.ts
var ConnectCountriesMapping = {
  "United Kingdom": "GB",
  "United States": "US",
  Ireland: "IE"
};

// src/repositories/appointment.repo.ts
var IAppointmentRepository = Symbol("AppointmentRepository");

// src/repositories/availability.alert.repo.ts
var IAvailabilityAlertsRepo = Symbol("AvailabilityAlertsRepo");

// src/repositories/book.repo.ts
var IBookRepository = Symbol("BookRepository");

// src/repositories/booking.brand.detail.ts
var IBookingBrandDetailRepository = Symbol(
  "BookingBrandDetailRepository"
);

// src/repositories/booking.policy.ts
var IBookingPolicyRepository = Symbol("BookingPolicyRepository");

// src/repositories/break.repo.ts
var IBreakRepository = Symbol("BreakRepository");

// src/repositories/customer.repo.ts
var ICustomerRepository = Symbol("CustomerRepository");

// src/repositories/google.analytics.repo.ts
var IGoogleAnalyticsRepo = Symbol("GoogleAnalyticsRepo");

// src/repositories/google.tag.manager.repo.ts
var IGoogleTagManagerRepo = Symbol("GoogleTagManagerRepo");

// src/repositories/location.repo.ts
var ILocationRepository = Symbol("LocationRepository");

// src/repositories/notifications.repo.ts
var INotificationsRepository = Symbol("NotificationsRepository");

// src/repositories/payment.account.repo.ts
var IPaymentAccountRepository = Symbol("PaymentAccountRepository");

// src/repositories/payment.transaction.repo.ts
var IPaymentTransactionRepository = Symbol(
  "PaymentTransactionRepository"
);

// src/repositories/refund.repo.ts
var IRefundRepository = Symbol("RefundRepository");

// src/repositories/service.repo.ts
var IServiceRepository = Symbol("ServiceRepository");

// src/repositories/timeoffs.repo.ts
var ITimeOffRepository = Symbol("TimeOffRepository");

// src/repositories/user.repo.ts
var IUserRepository = Symbol("UserRepository");

// src/repositories/working.day.repo.ts
var IWorkingDayRepository = Symbol("WorkingDayRepository");

// src/repositories/business.repo.ts
var IBusinessRepository = Symbol("BusinessRepo");

// src/repositories/paymentlog.repo.ts
var IPaymentLogRepository = Symbol("PaymentLogRepository");

// src/repositories/dashboard.repo.ts
var IDashboardRepository = Symbol("DashboardRepository");

// src/repositories/working.day.history.repo.ts
var IWorkingDayHistoryRepo = Symbol("WorkingDayHistoryRepo");

// src/repositories/communication.timeline.repo.ts
var ICommunicationTimelineRepo = Symbol("CommunicationTimelineRepo");

// src/repositories/notes.repo.ts
var INotesRepo = Symbol("NotesRepo");

// src/repositories/google.account.repo.ts
var IGoogleAccountRepo = Symbol("GoogleAccountRepo");

// src/repositories/google.calendar.events.repository.ts
var IGoogleCalendarEventsRepository = Symbol(
  "GoogleCalendarEventsRepository"
);

// src/repositories/microsoft.account.repo.ts
var IMicrosoftAccountRepo = Symbol("MicrosoftAccountRepo");

// src/repositories/microsoft.calendar.events.repository.ts
var IMicrosoftCalendarEventsRepository = Symbol(
  "MicrosoftCalendarEventsRepository"
);

// src/repositories/email.templates.repo.ts
var IEmailTemplatesRepo = Symbol("EmailTemplatesRepo");

// src/repositories/sms.templates.repo.ts
var ISmsTemplatesRepo = Symbol("SmsTemplatesRepo");

// src/repositories/application.settings.repo.ts
var IApplicationSettingsRepo = Symbol("ApplicationSettingsRepo");

// src/repositories/subscription.plan.repo.ts
var ISubscriptionPlanRepository = Symbol("SubscriptionPlanRepository");

// src/repositories/plan.features.repo.ts
var IPlanFeaturesRepository = Symbol("PlanFeaturesRepository");

// src/repositories/subscription.repo.ts
var ISubscriptionRepository = Symbol("SubscriptionRepository");

// src/repositories/card.repo.ts
var ICardRepository = Symbol("CardRepository");

// src/repositories/subscription.payment.repo.ts
var ISubscriptionPaymentRepo = Symbol("SubscriptionPaymentRepo");

// src/repositories/subscription.change.repo.ts
var ISubscriptionChangeRepo = Symbol("SubscriptionChangeRepo");

// src/repositories/dentally.location.repo.ts
var IDentallyLocationRepository = Symbol("DentallyLocationRepository");

// src/repositories/dentally.service.link.repo.ts
var IDentallyServiceLinkRepo = Symbol("DentallyServiceLinkRepo");

// src/repositories/dentally.logs.repo.ts
var IDentallyLogsRepo = Symbol("DentallyLogsRepo");

// src/repositories/business.review.repo.ts
var IBusinessReviewRepository = Symbol("BusinessReviewRepository");

// src/repositories/webhook.events.repo.ts
var IWebhookEventRepository = Symbol("WebhookEventRepository");

// src/use-cases/appointment/change.appointment.date.time.ts
var IChangeAppointmentDataTimeUseCase = Symbol(
  "ChangeAppointmentDataTimeUseCase"
);

// src/use-cases/appointment/change.appointment.status.ts
var IChangeAppointmentStatusUseCase = Symbol(
  "ChangeAppointmentStatusUseCase"
);

// src/use-cases/appointment/update.ts
var IUpdateAppointmentUseCase = Symbol("UpdateAppointmentUseCase");

// src/use-cases/appointment/delete.ts
var IDeleteAppointmentUseCase = Symbol("DeleteAppointmentUseCase");

// src/use-cases/appointment/create.public.appointment.ts
var ICreatePublicAppointmentUseCase = Symbol(
  "CreatePublicAppointmentUseCase"
);

// src/use-cases/appointment/create.public.appointment.without.payment.ts
var ICreatePublicAppointmentWithoutPaymentUseCase = Symbol(
  "CreatePublicAppointmentWithoutPaymentUseCase"
);

// src/use-cases/appointment/create.ts
var ICreateAppointmentUseCase = Symbol("CreateAppointmentUseCase");

// src/use-cases/appointment/bulk.update.status.ts
var IBulkUpdateStatusUseCase = Symbol("BulkUpdateStatusUseCase");

// src/use-cases/appointment/get.by.id.ts
var IGetByIdAppointmentUseCase = Symbol("GetByIdAppointmentUseCase");

// src/use-cases/appointment/get.all.by.location.ts
var IGetAllAppointmentsByLocationUseCase = Symbol(
  "GetAllAppointmentsByLocationUseCase"
);

// src/use-cases/appointment/fetch.appointments.gclid.by.location.for.google.sheets.ts
var IFetchAppointmentsGclidByLocationForGoogleSheetsUseCase = Symbol(
  "FetchAppointmentsGclidByLocationForGoogleSheetsUseCase"
);

// src/use-cases/appointment/get.all.by.location.with.pagination.ts
var IGetAllAppointmentsByLocationWithPaginationUseCase = Symbol(
  "GetAllAppointmentsByLocationWithPaginationUseCase"
);

// src/use-cases/appointment/get.all.by.month.ts
var IGetAllAppointmentByMonthUseCase = Symbol(
  "GetAllAppointmentByMonthUseCase"
);

// src/use-cases/appointment/get.appointment.summary.ts
var IGetAppointmentSummaryByBookingIdUseCase = Symbol(
  "GetAppointmentSummaryByBookingIdUseCase"
);

// src/use-cases/appointment/get.avaliable.dates.ts
var IGetAvaliableDatesUseCase = Symbol("GetAvaliableDatesUseCase");

// src/use-cases/appointment/get.avaliable.timeslots.ts
var IGetAvaliableTimeSlotsUseCase = Symbol(
  "GetAvaliableTimeSlotsUseCase"
);

// src/use-cases/appointment/search.appointments.usecase.ts
var ISearchAppointmentsWithPaginationUseCase = Symbol(
  "SearchAppointmentsWithPaginationUseCase"
);

// src/use-cases/appointment/get.provisional.booking.ts
var IGetProvisionalBookingUseCase = Symbol(
  "GetProvisionalBookingUseCase"
);

// src/use-cases/appointment/get.customer.information.by.appointment.id.ts
var IGetCustomerInformationByAppointmentIdUseCase = Symbol(
  "GetCustomerInformationByAppointmentIdUseCase"
);

// src/use-cases/appointment/update.public.appointment.usecase.ts
var IUpdatePublicAppointmentUseCase = Symbol(
  "UpdatePublicAppointmentUseCase"
);

// src/use-cases/appointment/get.avaliable.dates.for.admin.ts
var IGetAvaliableDatesForAdminUseCase = Symbol(
  "GetAvaliableDatesForAdminUseCase"
);

// src/use-cases/appointment/get.avaliable.timeslots.for.admin.ts
var IGetAvaliableTimeslotsForAdminUseCase = Symbol(
  "GetAvaliableTimeslotsForAdminUseCase"
);

// src/use-cases/appointment/get.avaliable.timeslots.v2.ts
var IGetAvaliableTimeSlotsV2UseCase = Symbol(
  "GetAvaliableTimeSlotsV2UseCase"
);

// src/use-cases/appointment/get.avaliable.timeslots.for.admin.v2.ts
var IGetAvaliableTimeslotsForAdminV2UseCase = Symbol(
  "GetAvaliableTimeslotsForAdminV2UseCase"
);

// src/use-cases/appointment/send.review.emails.for.appointments.ts
var ISendReviewEmailsForAppointmentsUseCase = Symbol(
  "SendReviewEmailsForAppointmentsUseCase"
);

// src/use-cases/appointment/mark.as.paid.at.counter.ts
var IMarkAsPaidAtCounterUseCase = Symbol("MarkAsPaidAtCounterUseCase");

// src/use-cases/appointment/sync.appointment.status.from.dentally.usecase.ts
var ISyncAppointmentStatusFromDentallyUseCase = Symbol(
  "SyncAppointmentStatusFromDentallyUseCase"
);

// src/use-cases/appointment/sync.appointment.time.from.dentally.usecase.ts
var ISyncAppointmentTimeFromDentallyUseCase = Symbol(
  "SyncAppointmentTimeFromDentallyUseCase"
);

// src/use-cases/appointment/sync.appointment-deletion.from.dentally.usecase.ts
var ISyncAppointmentDeletionFromDentallyUseCase = Symbol(
  "SyncAppointmentDeletionFromDentallyUseCase"
);

// src/use-cases/appointment/take.payment.public.appointment.usecase.ts
var ITakePaymentPublicAppointmentUseCase = Symbol(
  "TakePaymentPublicAppointmentUseCase"
);

// src/use-cases/appointment/check.if.slot.booked.ts
var ICheckIfSlotBookedUseCase = Symbol("CheckIfSlotBookedUseCase");

// src/use-cases/appointment/check.appointment.detail.ts
var ICheckAppointmentDetailUseCase = Symbol(
  "CheckAppointmentDetailUseCase"
);

// src/use-cases/appointment/check.if.appointment.paid.ts
var ICheckIfAppointmentIsPaidUseCase = Symbol(
  "CheckIfAppointmentIsPaidUseCase"
);

// src/use-cases/appointment/process.stripe-appointment.payment.usecase.ts
var IProcessStripeAppointmentPaymentUseCase = Symbol(
  "ProcessStripeAppointmentPaymentUseCase"
);

// src/use-cases/booking-brand-detail/get.by.location.ts
var IGetBookingBrandDetailsByLocationUseCase = Symbol(
  "GetBookingBrandDetailsByLocationUseCase"
);

// src/use-cases/booking-brand-detail/register.ts
var IRegisterBookingBrandDetailUseCase = Symbol(
  "RegisterBookingBrandDetailUseCase"
);

// src/use-cases/booking-brand-detail/update.ts
var IUpdateBookingBrandDetailsUseCase = Symbol(
  "UpdateBookingBrandDetailsUseCase"
);

// src/use-cases/booking-policy/get.by.location.ts
var IGetBookingPoliciesByLocationUseCase = Symbol(
  "GetBookingPoliciesByLocationUseCase"
);

// src/use-cases/booking-policy/register.ts
var IRegisterBookingPolicyUseCase = Symbol(
  "RegisterBookingPolicyUseCase"
);

// src/use-cases/booking-policy/update.ts
var IUpdateBookingPoliciesUseCase = Symbol(
  "UpdateBookingPoliciesUseCase"
);

// src/use-cases/break/create.ts
var ICreateBreakUseCase = Symbol("CreateBreakUseCase");

// src/use-cases/break/delete.ts
var IDeleteBreakUseCase = Symbol("DeleteBreakUseCase");

// src/use-cases/break/get.by.id.ts
var IGetByIdBreakUseCase = Symbol("GetByIdBreakUseCase");

// src/use-cases/break/update.ts
var IUpdateBreakUseCase = Symbol("UpdateBreakUseCase");

// src/use-cases/break/get.all.breaks.by.location.ts
var IGetAllBreaksByLocation = Symbol("GetAllBreaksByLocation");

// src/use-cases/break/get.all.by.location.ts
var IGetAllBreaksByLocationUseCaseForHistory = Symbol(
  "GetAllBreaksByLocationUseCaseForHistory"
);

// src/use-cases/customer/delete.customer.usecase.ts
var IDeleteCustomerUseCase = Symbol("DeleteCustomerUseCase");

// src/use-cases/customer/get.all.customer.by.location.with.pagination.usecase.ts
var IGetAllCustomerByLocationWithPaginationUseCase = Symbol(
  "GetAllCustomerByLocationWithPaginationUseCase"
);

// src/use-cases/customer/get.all.customer.usecase.ts
var IGetAllCustomerByLocationUseCase = Symbol(
  "GetAllCustomerByLocationUseCase"
);

// src/use-cases/customer/get.customer.by.id.usecase.ts
var IGetCustomerByIdUseCase = Symbol("GetCustomerByIdUseCase");

// src/use-cases/customer/register.customer.usecase.ts
var IRegisterCustomerUseCase = Symbol("RegisterCustomerUseCase");

// src/use-cases/customer/search.customer.with.pagination.usecase.ts
var ISearchCustomerWithPaginationUseCase = Symbol(
  "SearchCustomerWithPaginationUseCase"
);

// src/use-cases/customer/update.custome.usecase.ts
var IUpdateCustomerUseCase = Symbol("UpdateCustomerUseCase");

// src/use-cases/customer/sync.dentally-customer.with-slot.usecase.ts
var ISyncCustomerFromDentallyWithSlotUseCase = Symbol(
  "SyncCustomerFromDentallyWithSlotUseCase"
);

// src/use-cases/google-analytics/create.google.analytics.ts
var ICreateGoogleAnalyticsUseCase = Symbol(
  "CreateGoogleAnalyticsUseCase"
);

// src/use-cases/google-analytics/edit.google.analytics.ts
var IEditGoogleAnalyticsUseCase = Symbol("EditGoogleAnalyticsUseCase");

// src/use-cases/google-analytics/find.by.location.ts
var IFindGoogleAnalyticsByLocationUseCase = Symbol(
  "FindGoogleAnalyticsByLocationUseCase"
);

// src/use-cases/google-tag-manager/create.google.tag.manager.ts
var ICreateGoogleTagManagerUseCase = Symbol(
  "CreateGoogleTagManagerUseCase"
);

// src/use-cases/google-tag-manager/edit.google.tag.manager.ts
var IEditGoogleTagManagerUseCase = Symbol(
  "EditGoogleTagManagerUseCase"
);

// src/use-cases/google-tag-manager/find.by.location.ts
var IFindGoogleTagManagerByLocationUseCase = Symbol(
  "FindGoogleTagManagerByLocationUseCase"
);

// src/use-cases/google-tag-manager/is.google.tag.manger.connected.usecase.ts
var IIsGoogleTagMangerConnectedUseCase = Symbol(
  "IsGoogleTagMangerConnectedUseCase"
);

// src/use-cases/location/change.cancellation.policy.ts
var IChangeLocationCancellationPolicy = Symbol(
  "ChangeLocationCancellationPolicy"
);

// src/use-cases/location/change.location.schedule.window.ts
var IChangeLocationScheduleWindowUseCase = Symbol(
  "ChangeLocationScheduleWindowUseCase"
);

// src/use-cases/location/get.all.locations.ts
var IGetAllLocationUseCase = Symbol("GetAllLocationUseCase");

// src/use-cases/location/get.all.locations.for.dentist.hub.ts
var IGetAllLocationsForDentistHubUseCase = Symbol(
  "GetAllLocationsForDentistHubUseCase"
);

// src/use-cases/location/get.all.locations.with.pagination.ts
var IGetAllLocationWithPaginationUseCase = Symbol(
  "GetAllLocationWithPaginationUseCase"
);

// src/use-cases/location/get.by.id.location.ts
var IGetByIdLocationUseCase = Symbol("GetByIdLocationUseCase");

// src/use-cases/location/get.plain.location.by.id.ts
var IGetPlainLocationByIdUseCase = Symbol(
  "GetPlainLocationByIdUseCase"
);

// src/use-cases/location/get.cancellation.policy.ts
var IGetCancellationPolicyUseCase = Symbol(
  "GetCancellationPolicyUseCase"
);

// src/use-cases/location/register.location.ts
var IRegisterLocationUseCase = Symbol("RegisterLocationUseCase");

// src/use-cases/location/update.location.ts
var IUpdateLocationUseCase = Symbol("UpdateLocationUseCase");

// src/use-cases/location/delete.location.ts
var IDeleteLocationUseCase = Symbol("DeleteLocationUseCase");

// src/use-cases/location/update.customer.reminder.time.location.ts
var IUpdateCustomerReminderTimeUseCase = Symbol(
  "UpdateCustomerReminderTimeUseCase"
);

// src/use-cases/location/update.left.content.for.booking.page.ts
var IUpdateLeftContentForBookingPage = Symbol(
  "UpdateLeftContentForBookingPage"
);

// src/use-cases/location/update.double.booking.settings.ts
var IUpdateDoubleBookingSettings = Symbol(
  "UpdateDoubleBookingSettings"
);

// src/use-cases/location/update.terms.and.conditions.ts
var IUpdateTermsAndConditions = Symbol("UpdateTermsAndConditions");

// src/use-cases/location/update.slots.timeformat.ts
var IUpdateSlotsTimeFormatUseCase = Symbol(
  "UpdateSlotsTimeFormatUseCase"
);

// src/use-cases/location/get.content.for.booking.page.ts
var IGetContentForBookingPageUseCase = Symbol(
  "GetContentForBookingPageUseCase"
);

// src/use-cases/location/update.right.content.for.payment.page.ts
var IUpdateRightContentForPaymentPage = Symbol(
  "UpdateRightContentForPaymentPage"
);

// src/use-cases/location/check.location.eligibility.ts
var ICheckLocationEligibilityUseCase = Symbol(
  "CheckLocationEligibilityUseCase"
);

// src/use-cases/location/change.backdate.for.location.ts
var IChangeBackdateForLocationUseCase = Symbol(
  "ChangeBackdateForLocationUseCase"
);

// src/use-cases/location/update.email.sender.name.usecase.ts
var IUpdateEmailSenderNameUseCase = Symbol(
  "UpdateEmailSenderNameUseCase"
);

// src/use-cases/location/update.application.fee.by.location.ts
var IUpdateApplicationFeeByLocationUseCase = Symbol(
  "UpdateApplicationFeeByLocationUseCase"
);

// src/use-cases/location/get.location.by.google.place.id.ts
var IGetLocationByGooglePlaceIdUseCase = Symbol(
  "GetLocationByGooglePlaceIdUseCase"
);

// src/use-cases/location/update.location.status.usecase.ts
var IUpdateLocationStatusUseCase = Symbol(
  "UpdateLocationStatusUseCase"
);

// src/use-cases/notifications/get.all.by.location.ts
var IGetPastTwoMonthsNotificationByLocationUseCase = Symbol(
  "GetPastTwoMonthsNotificationByLocationUseCase"
);

// src/use-cases/notifications/mark.notifications.read.ts
var IMarkNotificationsReadUseCase = Symbol(
  "MarkNotificationsReadUseCase"
);

// src/use-cases/payment-account/bind.square.locationid.usecase.ts
var IBindSquareLocationIdUseCase = Symbol(
  "BindSquareLocationIdUseCase"
);

// src/use-cases/payment-account/checkPaymentAccountExists.ts
var ICheckPaymentAccountExists = Symbol("CheckPaymentAccountExists");

// src/use-cases/payment-account/create.dojo.payment.account.ts
var ICreateDojoPaymentAccountUseCase = Symbol(
  "CreateDojoPaymentAccountUseCase"
);

// src/use-cases/payment-account/create.square.payment.account.ts
var ICreateSquarePaymentAccountUseCase = Symbol(
  "CreateSquarePaymentAccountUseCase"
);

// src/use-cases/payment-account/delete.square.account.usecase.ts
var IDeleteSquarePaymentAccountUseCase = Symbol(
  "DeleteSquarePaymentAccountUseCase"
);

// src/use-cases/payment-account/delete.ts
var IDeletePaymentAccountUseCase = Symbol(
  "DeletePaymentAccountUseCase"
);

// src/use-cases/payment-account/get.all.by.location.ts
var IGetAllPaymentAccountsByLocationUseCase = Symbol(
  "GetAllPaymentAccountsByLocationUseCase"
);

// src/use-cases/payment-account/get.all.by.location.with.pagination.ts
var IGetAllPaymentTransactionsByLocationWithPagination = Symbol(
  "GetAllPaymentTransactionsByLocationWithPagination"
);

// src/use-cases/payment-account/get.by.id.ts
var IGetByIdPaymentAccountUseCase = Symbol(
  "GetByIdPaymentAccountUseCase"
);

// src/use-cases/payment-account/is.square.connected.usecase.ts
var IIsSquareConnectedUseCase = Symbol("IsSquareConnectedUseCase");

// src/use-cases/payment-account/update.ts
var IUpdatePaymentAccountUseCase = Symbol(
  "UpdatePaymentAccountUseCase"
);

// src/use-cases/payment-account/get.all.connected.payment.account.ts
var IGetAllConnectedPaymentAccountsByLocation = Symbol(
  "GetAllConnectedPaymentAccountsByLocation"
);

// src/use-cases/payment-account/get.current.connected.account.usecase.ts
var IGetCurrentConnectedPaymentAccountUseCase = Symbol(
  "GetCurrentConnectedPaymentAccountUseCase"
);

// src/use-cases/payment-account/disconnect.current.linked.payment.account.by.location.usecase.ts
var IDisconnectCurrentLinkedPaymentAccountByLocationUseCase = Symbol(
  "DisconnectCurrentLinkedPaymentAccountByLocationUseCase"
);

// src/use-cases/payment-account/delete.payment.provider.by.location.ts
var IDeletePaymentProviderByLocationUseCase = Symbol(
  "DeletePaymentProviderByLocationUseCase"
);

// src/use-cases/payment-account/delete.stripe.account.usecase.ts
var IDeleteStripePaymentAccountUseCase = Symbol(
  "DeleteStripePaymentAccountUseCase"
);

// src/use-cases/payment-transactions/get.all.transactions.by.location.usecase.ts
var IGetAllSquarePaymentTransactionsByLocationUseCase = Symbol(
  "GetAllSquarePaymentTransactionsByLocationUseCase"
);

// src/use-cases/payment-transactions/search.all.transactions.by.location.with.pagination.usecase.ts
var ISearchAllTransactionsByLocationWithPaginationUseCase = Symbol(
  "SearchAllTransactionsByLocationWithPaginationUseCase"
);

// src/use-cases/refresh-token/refresh-token.usecase.ts
var IRefreshTokenUseCase = Symbol("RefreshTokenUseCase");

// src/use-cases/refunds/getAllSquareRefundsBySquarePaymentTransaction.ts
var IGetAllSquareRefundsBySquarePaymentTransaction = Symbol(
  "GetAllSquareRefundsBySquarePaymentTransaction"
);

// src/use-cases/refunds/issue.square-refund.usecase.ts
var IIssueSquareRefundUseCase = Symbol("IssueSquareRefundUseCase");

// src/use-cases/refunds/update.refund.status.usecase.ts
var IUpdateRefundStatusUseCase = Symbol("UpdateRefundStatusUseCase");

// src/use-cases/refunds/find.all.refunds.by.location.with.pagination.usecase.ts
var IFindAllRefundsByLocationWithPaginationUseCase = Symbol(
  "FindAllRefundsByLocationWithPaginationUseCase"
);

// src/use-cases/refunds/search.refunds.by.location.with.pagination.usecase.ts
var ISearchRefundsByLocationWithPaginationUseCase = Symbol(
  "SearchRefundsByLocationWithPaginationUseCase"
);

// src/use-cases/refunds/issue.refund.use.case.ts
var IIssueRefundUseCase = Symbol("IssueRefundUseCase");

// src/use-cases/refunds/issue.stripe-refund.usecase.ts
var IIssueStripeRefundUseCase = Symbol("IssueStripeRefundUseCase");

// src/use-cases/refunds/update.refund.stripe.usecase.ts
var IUpdateStripeRefundStatusUseCase = Symbol(
  "UpdateStripeRefundStatusUseCase"
);

// src/use-cases/revoke-token/revoke-token.usecase.ts
var IRevokeTokenUseCase = Symbol("RevokeTokenUseCase");

// src/use-cases/service/create.ts
var ICreateServiceUseCase = Symbol("CreateServiceUseCase");

// src/use-cases/service/delete.ts
var IDeleteServiceUseCase = Symbol("DeleteServiceUseCase");

// src/use-cases/service/get.all.by.location.ts
var IGetAllServicesByLocation = Symbol("GetAllServicesByLocation");

// src/use-cases/service/get.all.live.services.by.location.ts
var IGetAllLiveServiceByLocationUseCase = Symbol(
  "GetAllLiveServiceByLocationUseCase"
);

// src/use-cases/service/get.all.services.by.location.for.back.office.ts
var IGetAllServicesByLocationForBackOfficeUseCase = Symbol(
  "GetAllServicesByLocationForBackOfficeUseCase"
);

// src/use-cases/service/get.all.ts
var IGetAllServiceUseCase = Symbol("GetAllServiceUseCase");

// src/use-cases/service/get.by.id.ts
var IGetServiceByIdUseCase = Symbol("GetServiceByIdUseCase");

// src/use-cases/service/update.ts
var IUpdateServiceUseCase = Symbol("UpdateServiceUsecase");

// src/use-cases/square/get.all.square.locations.ts
var IGetAllSquareLocations = Symbol("GetAllSquareLocations");

// src/use-cases/time-offs/create.ts
var ICreateTimeOffUseCase = Symbol("CreateTimeOffUseCase");

// src/use-cases/time-offs/delete.ts
var IDeleteTimeOffUseCase = Symbol("DeleteTimeOffUseCase");

// src/use-cases/time-offs/get.all.by.location.ts
var IGetAllTimeOffsByLocationWithPaginationUseCase = Symbol(
  "IGetAllTimeOffsByLocationWithPaginationUseCase"
);

// src/use-cases/time-offs/get.by.id.ts
var IGetByIdTimeOffUseCase = Symbol("GetByIdTimeOffUseCase");

// src/use-cases/time-offs/update.ts
var IUpdateTimeOffUseCase = Symbol("UpdateTimeOffUseCase");

// src/use-cases/time-offs/get.all.by.location.for.calendar.ts
var IGetAllTimeOffsByLocationForCalendarUseCase = Symbol(
  "GetAllTimeOffsByLocationForCalendarUseCase"
);

// src/use-cases/user/block.user.ts
var IBlockUserUseCase = Symbol("BlockUserUseCase");

// src/use-cases/user/get.all.admins.by.location.ts
var IGetAllAdminsByLocationUseCase = Symbol(
  "GetAllAdminsByLocationUseCase"
);

// src/use-cases/user/get.all.super.and.platform.admins.ts
var IGetAllSuperAndPlatformAdminsUseCase = Symbol(
  "GetAllSuperAndPlatformAdminsUseCase"
);

// src/use-cases/user/get.all.users.ts
var IGetAllUsersUseCase = Symbol("GetAllUsersUseCase");

// src/use-cases/user/get.user.byid.ts
var IGetUserByIdUseCase = Symbol("GetUserByIdUseCase");

// src/use-cases/user/hard.delete.user.usecase.ts
var IHardDeleteUserUseCase = Symbol("HardDeleteUserUseCase");

// src/use-cases/user/login.user.ts
var ILoginUserUseCase = Symbol("LoginUserUseCase");

// src/use-cases/user/register.admin.ts
var IRegisterAdminUseCase = Symbol("RegisterAdminUseCase");

// src/use-cases/user/update.user.profile.ts
var IUpdateUserProfileUseCase = Symbol("UpdateUserProfileUseCase");

// src/use-cases/user/update.user.ts
var IUpdateUserUseCase = Symbol("UpdateUserUseCase");

// src/use-cases/user/send.user.reset.email.ts
var ISendUserResetEmailUseCase = Symbol("SendUserResetEmailUseCase");

// src/use-cases/user/reset.password.for.user.ts
var IResetPasswordForUserUseCase = Symbol(
  "ResetPasswordForUserUseCase"
);

// src/use-cases/user/update.email.verification.status.ts
var IUpdateEmailVerificationStatus = Symbol(
  "UpdateEmailVerificationStatus"
);

// src/use-cases/user/update.user.status.ts
var IUpdateUserStatusUseCase = Symbol("UpdateUserStatusUseCase");

// src/use-cases/user/admin.initiated.password.reset.ts
var IAdminInitiatedPasswordResetUseCase = Symbol(
  "AdminInitiatedPasswordResetUseCase"
);

// src/use-cases/user/initiate.email.change.request.ts
var IInitiateEmailChangeRequestUseCase = Symbol(
  "InitiateEmailChangeRequestUseCase"
);

// src/use-cases/user/verify.email.change.request.ts
var IVerifyEmailChangeRequestUseCase = Symbol(
  "VerifyEmailChangeRequestUseCase"
);

// src/use-cases/user/verify.invite.ts
var IVerifyInviteUseCase = Symbol("VerifyInviteUseCase");

// src/use-cases/user/update.password.ts
var IUpdatePasswordUseCase = Symbol("UpdatePasswordUseCase");

// src/use-cases/user/resend.user.invite.usecase.ts
var IResendUserInviteUseCase = Symbol("ResendUserInviteUseCase");

// src/use-cases/working-day/get.all.by.location.include.breaks.ts
var IGetAllWorkingDaysByLocationIncludeBreaks = Symbol(
  "GetAllWorkingDaysByLocationIncludeBreaks"
);

// src/use-cases/working-day/get.all.by.location.ts
var IGetAllWorkDaysByLocationUseCase = Symbol(
  "GetAllWorkDaysByLocationUseCase"
);

// src/use-cases/working-day/register.ts
var IRegisterWorkingDayUseCase = Symbol("RegisterWorkingDayUseCase");

// src/use-cases/working-day/update.ts
var IUpdateWorkingDaysUseCase = Symbol("UpdateWorkingDaysUseCase");

// src/use-cases/business/get.all.business.usecase.ts
var IGetAllBusinessUseCase = Symbol("GetAllBusinessUseCase");

// src/use-cases/business/get.all.business.with.location.usecase.ts
var IGetAllBusinessWithLocationUseCase = Symbol(
  "GetAllBusinessWithLocationUseCase"
);

// src/use-cases/business/add.business.usecase.ts
var IAddBusinessUseCase = Symbol("AddBusinessUseCase");

// src/use-cases/business/get.business.with.location.by.subdomain.usecase.ts
var IGetBusinessWithLocationBySubdomainUseCase = Symbol(
  "GetBusinessWithLocationBySubdomainUseCase"
);

// src/use-cases/business/get.business.by.id.usecase.ts
var IGetBusinessByIdUseCase = Symbol("GetBusinessByIdUseCase");

// src/use-cases/business/delete.business.usecase.ts
var IDeleteBusinessUseCase = Symbol("DeleteBusinessUseCase");

// src/use-cases/business/update.business.usecase.ts
var IUpdateBusinessUseCase = Symbol("UpdateBusinessUseCase");

// src/use-cases/business/update.application.fee.by.business.ts
var IUpdateApplicationFeeByBusinessUseCase = Symbol(
  "UpdateApplicationFeeByBusinessUseCase"
);

// src/use-cases/business/list-subdomains.usecase.ts
var IListSubdomainsUseCase = Symbol("ListSubdomainsUseCase");

// src/use-cases/business/business.signup.with.subscription.usecase.ts
var IBusinessSignupWithSubscriptionUseCase = Symbol(
  "BusinessSignupWithSubscriptionUseCase"
);

// src/use-cases/payment-link-shortner/payment.link.shortener.ts
var IPaymentLinkShortenerUseCase = Symbol(
  "PaymentLinkShortenerUseCase"
);

// src/use-cases/dashboard/get.dashboard.for.location.ts
var IGetDashboardForLocation = Symbol("GetDashboardForLocation");

// src/use-cases/dashboard/get.report.for.business.ts
var IGetReportForBusinessUseCase = Symbol(
  "GetReportForBusinessUseCase"
);

// src/use-cases/dashboard/get.report.for.sms.and.email.of.business.ts
var IGetReportForSmsAndEmailOfBusiness = Symbol(
  "GetReportForSmsAndEmailOfBusiness"
);

// src/use-cases/dashboard/get.dashboard.for.business.ts
var IGetDashboardForBusiness = Symbol("GetDashboardForBusiness");

// src/use-cases/dashboard/get.report.for.all.time.revenue.ts
var IGetReportForAllTimeRevenue = Symbol("GetReportForAllTimeRevenue");

// src/use-cases/dashboard/get.report.for.all.time.app.fee.usecase.ts
var IGetReportForAllTimeAppFeeUseCase = Symbol(
  "GetReportForAllTimeAppFeeUseCase"
);

// src/use-cases/working-day-history/get.all.by.location.ts
var IGetAllWorkingDaysHistoryByLocationUseCase = Symbol(
  "GetAllWorkingDaysHistoryByLocationUseCase"
);

// src/use-cases/payment-log/find.payment.log.by.appointment.id.ts
var IFindPaymentLogByAppointmentId = Symbol(
  "FindPaymentLogByAppointmentId"
);

// src/use-cases/payment-log/find.all.payment.log.by.locationid.with.pagination.ts
var IFindAllPaymentLogByLocationIdWithPagination = Symbol(
  "FindAllPaymentLogByLocationIdWithPagination"
);

// src/use-cases/payment-log/search.payment.log.by.locationid.with.pagination.ts
var ISearchPaymentLogByLocationIdWithPagination = Symbol(
  "SearchPaymentLogByLocationIdWithPagination"
);

// src/use-cases/payment-log/find.all.payment.logs.ts
var IFindAllPaymentLogsUseCase = Symbol("FindAllPaymentLogsUseCase");

// src/use-cases/communication-timeline/get.communication.timeline.by.id.ts
var IGetCommunicationTimelineById = Symbol(
  "GetCommunicationTimelineById"
);

// src/use-cases/communication-timeline/update.communication.timeline.by.id.ts
var IUpdateCommunicationTimelineById = Symbol(
  "UpdateCommunicationTimelineById"
);

// src/use-cases/communication-timeline/get.complete.communication.timeline.by.customer.id.ts
var IGetCompleteCommunicationTimelineByCustomerId = Symbol(
  "GetCompleteCommunicationTimelineByCustomerId"
);

// src/use-cases/communication-timeline/get.complete.communication.timeline.by.appointment.id.ts
var IGetCompleteCommunicationTimelineByAppointmentId = Symbol(
  "GetCompleteCommunicationTimelineByAppointmentId"
);

// src/use-cases/notes/add.note.ts
var IAddNoteUseCase = Symbol("AddNoteUseCase");

// src/use-cases/notes/get.all.notes.by.customer.id.ts
var IGetAllNotesByCustomerIdUseCase = Symbol(
  "GetAllNotesByCustomerIdUseCase"
);

// src/use-cases/notes/update.note.ts
var IUpdateNote = Symbol("UpdateNote");

// src/use-cases/notes/delete.note.ts
var IDeleteNoteUseCase = Symbol("DeleteNoteUseCase");

// src/use-cases/notes/get.all.notes.by.appointment.id.ts
var IGetAllNotesByAppointmentId = Symbol("GetAllNotesByAppointmentId");

// src/use-cases/signup/business.signup.usecase.ts
var IBusinessSignupUseCase = Symbol("BusinessSignupUseCase");

// src/use-cases/signup/add.business-location.name.usecase.ts
var IAddBusinessLocationNameUseCase = Symbol(
  "AddBusinessLocationNameUseCase"
);

// src/use-cases/google-account-oauth/register.google.account.oauth.ts
var IRegisterGoogleAccountOauthUseCase = Symbol(
  "RegisterGoogleAccountOauthUseCase"
);

// src/use-cases/google-account-oauth/disconnect.google.account.ts
var IDisconnectGoogleAccountUseCase = Symbol(
  "DisconnectGoogleAccountUseCase"
);

// src/use-cases/google-account-oauth/check.if.google.account.connected.ts
var ICheckIfGoogleAccountConnectedUseCase = Symbol(
  "CheckIfGoogleAccountConnectedUseCase"
);

// src/use-cases/google-account-oauth/get.google.account.by.location.ts
var IGetGoogleAccountByLocationUseCase = Symbol(
  "GetGoogleAccountByLocationUseCase"
);

// src/use-cases/google-calendar-events/sync.google.months.calendar.events.usecase.ts
var ISyncGoogleMonthsCalendarEventsUseCase = Symbol(
  "SyncGoogleMonthsCalendarEventsUseCase"
);

// src/use-cases/google-calendar-events/remove.all.google.events.usecase.ts
var IRemoveAllGoogleEventsUseCase = Symbol(
  "RemoveAllGoogleEventsUseCase"
);

// src/use-cases/google-calendar-events/get.all.calendar.events.by.start.and.end.time.ts
var IGetAllCalendarEventsByStartAndEndTimeUseCase = Symbol(
  "GetAllCalendarEventsByStartAndEndTimeUseCase"
);

// src/use-cases/google-calendar-events/handle.calendar.webhook.sync.ts
var IHandleCalendarWebhookSyncUseCase = Symbol(
  "HandleCalendarWebhookSyncUseCase"
);

// src/use-cases/google-calendar-events/delete.google.calendar.event.using.api.ts
var IDeleteGoogleCalendarEventUsingApiUseCase = Symbol(
  "DeleteGoogleCalendarEventUsingApiUseCase"
);

// src/use-cases/google-calendar-events/exclude.event.from.blocking.usecase.ts
var IExcludeEventFromBlockingUseCase = Symbol(
  "ExcludeEventFromBlockingUseCase"
);

// src/use-cases/microsoft-oauth-account/register.microsoft.account.usecase.ts
var IRegisterMicrosoftAccountUseCase = Symbol(
  "RegisterMicrosoftAccountUseCase"
);

// src/use-cases/microsoft-oauth-account/check.if.microsoft.account.connected.ts
var ICheckIfMicrosoftAccountConnectedUseCase = Symbol(
  "CheckIfMicrosoftAccountConnectedUseCase"
);

// src/use-cases/microsoft-oauth-account/disconnect.microsoft.account.usecase.ts
var IDisconnectMicrosoftAccountUseCase = Symbol(
  "DisconnectMicrosoftAccountUseCase"
);

// src/use-cases/microsoft-calendar-events/sync.microsoft.calendar.events.usecase.ts
var ISyncMicrosoftCalendarEventsUseCase = Symbol(
  "SyncMicrosoftCalendarEventsUseCase"
);

// src/use-cases/microsoft-calendar-events/get.all.microsoft.events.by.location.and.state.end.time.ts
var IGetAllMicrosoftEventsByLocationAndStateEndTime = Symbol(
  "GetAllMicrosoftEventsByLocationAndStateEndTime"
);

// src/use-cases/microsoft-calendar-events/sync.microsoft.current.event.by.webhook.ts
var ISyncMicrosoftCurrentEventByWebhook = Symbol(
  "SyncMicrosoftCurrentEventByWebhook"
);

// src/use-cases/microsoft-calendar-events/delete.microsoft.event.by.api.ts
var IDeleteMicrosoftEventByApiUseCase = Symbol(
  "DeleteMicrosoftEventByApiUseCase"
);

// src/use-cases/microsoft-calendar-events/exclude.microsoft.event.from.blocking.usecase.ts
var IExcludeMicrosoftEventFromBlockingUseCase = Symbol(
  "ExcludeMicrosoftEventFromBlockingUseCase"
);

// src/use-cases/email-templates/get.all.variables.ts
var IGetAllEmailVariables = Symbol("GetAllEmailVariables");

// src/use-cases/email-templates/get.email.templates.by.location.ts
var IGetEmailTemplatesByLocationUseCase = Symbol(
  "GetEmailTemplatesByLocationUseCase"
);

// src/use-cases/email-templates/update.email.template.ts
var IUpdateEmailTemplateUseCase = Symbol("UpdateEmailTemplateUseCase");

// src/use-cases/email-templates/get.email.payload.values.ts
var IGetEmailPayloadValuesUseCase = Symbol(
  "GetEmailPayloadValuesUseCase"
);

// src/use-cases/sms-templates/get.sms.templates.by.location.ts
var IGetSmsTemplatesByLocationUseCase = Symbol(
  "GetSmsTemplatesByLocationUseCase"
);

// src/use-cases/sms-templates/update.sms.template.by.id.ts
var IUpdateSmsTemplateByIdUseCase = Symbol(
  "UpdateSmsTemplateByIdUseCase"
);

// src/use-cases/application-settings/get.all.application.settings.ts
var IGetAllApplicationSettingsUseCase = Symbol(
  "GetAllApplicationSettingsUseCase"
);

// src/use-cases/application-settings/update.application.settings.ts
var IUpdateApplicationSettingsUseCase = Symbol(
  "UpdateApplicationSettingsUseCase"
);

// src/use-cases/application-fee/get.application.fees.all.businesses.ts
var IGetApplicationFeesAllBusinessesUseCase = Symbol(
  "GetApplicationFeesAllBusinessesUseCase"
);

// src/use-cases/subscription-plans/add.subscription.plan.ts
var IAddSubscriptionPlanUseCase = Symbol("AddSubscriptionPlanUseCase");

// src/use-cases/subscription-plans/delete.subscription.plan.ts
var IDeleteSubscriptionPlanUseCase = Symbol(
  "DeleteSubscriptionPlanUseCase"
);

// src/use-cases/subscription-plans/find.all.subscription.plans.ts
var IFindAllSubscriptionPlansUseCase = Symbol(
  "FindAllSubscriptionPlansUseCase"
);

// src/use-cases/subscription-plans/update.subscription.plan.ts
var IUpdateSubscriptionPlanUseCase = Symbol(
  "UpdateSubscriptionPlanUseCase"
);

// src/use-cases/subscription-plans/get.landing.page.plans.ts
var IGetLandingPagePlansUseCase = Symbol("GetLandingPagePlansUseCase");

// src/use-cases/subscriptions/find.all.subscription.details.ts
var IFindAllSubscriptionDetailsUseCase = Symbol(
  "FindAllSubscriptionDetailsUseCase"
);

// src/use-cases/subscriptions/upgrade.subscription.plan.ts
var IUpgradeSubscriptionPlanUseCase = Symbol(
  "UpgradeSubscriptionPlanUseCase"
);

// src/use-cases/subscriptionPayments/get.payment.by.subscription.id.ts
var IGetPaymentBySubscriptionIdUseCase = Symbol(
  "GetPaymentBySubscriptionIdUseCase"
);

// src/use-cases/card/add.card.usecase.ts
var IAddCardUseCase = Symbol("AddCardUseCase");

// src/use-cases/card/find.card.by.user.id.usecase.ts
var IFindCardByUserIdUseCase = Symbol("FindCardByUserIdUseCase");

// src/use-cases/stripe/connect.stripe.usecase.ts
var IConnectStripeUseCase = Symbol("ConnecStripeUseCase");

// src/use-cases/stripe/connect.stripe.refresh.url.ts
var IConnectStripeRefreshUrl = Symbol("ConnectStripeRefreshUrl");

// src/use-cases/stripe/handle.connect.stripe.account.status.ts
var IHandleConnectStripeAccountStatusUseCase = Symbol(
  "HandleConnectStripeAccountStatusUseCase"
);

// src/use-cases/stripe/create.appointment.payment.intent.usecase.ts
var ICreateAppointmentPaymentIntentUseCase = Symbol(
  "CreateAppointmentPaymentIntentUseCase"
);

// src/use-cases/dentally-location/find.dentally.location.by.location-id.ts
var IFindDentallyLocationByLocationIdUseCase = Symbol(
  "FindDentallyLocationByLocationIdUseCase"
);

// src/use-cases/dentally-location/connect.or.update.dentally.location.usecase.ts
var IConnectOrUpdateDentallyLocationTokenUseCase = Symbol(
  "ConnectOrUpdateDentallyLocationTokenUseCase"
);

// src/use-cases/dentally-location/get.practioners.by.location.id.usecase.ts
var IGetPractionersByLocationIdUseCase = Symbol(
  "GetPractionersByLocationIdUseCase"
);

// src/use-cases/dentally-location/bind.practioner.site.with.slot-location.usecase.impl.ts
var IBindPractionerSiteWithSlotLocationUseCase = Symbol(
  "BindPractionerSiteWithSlotLocationUseCase"
);

// src/use-cases/dentally-location/find.dentally-location.by.id.usecase.ts
var IFindDentallyLocationByIdUseCase = Symbol(
  "FindDentallyLocationByIdUseCase"
);

// src/use-cases/dentally-location/get.sites.by.location.id.usecase.ts
var IGetSitesByLocationIdUseCase = Symbol(
  "GetSitesByLocationIdUseCase"
);

// src/use-cases/dentally-location/get.dentally-reasons.by.location.id.usecase.ts
var IGetDentallyReasonsByLocationIdUseCase = Symbol(
  "GetDentallyReasonsByLocationIdUseCase"
);

// src/use-cases/dentally-location/update.patient.parameters.usecase.ts
var IUpdatePatientParamtersUseCase = Symbol(
  "UpdatePatientParamtersUseCase"
);

// src/use-cases/dentally-location/get.dentally.active.payment.plans.by.location-id.usecase.ts
var IGetDentallyActivePaymentPlansByLocationIdUseCase = Symbol(
  "GetDentallyActivePaymentPlansByLocationIdUseCase"
);

// src/use-cases/dentally-location/toggle-integration.status.usecase.ts
var IToggleIntegrationStatusUseCase = Symbol(
  "ToggleIntegrationStatusUseCase"
);

// src/use-cases/dentally-location/disconnect.dentally-integration.usecase.ts
var IDisconnectDentallyIntegrationUseCase = Symbol(
  "DisconnectDentallyIntegrationUseCase"
);

// src/use-cases/dentally-service-link/bulk.update.service.link.usecase.ts
var IBulkUpdateServiceLinkUseCase = Symbol(
  "BulkUpdateServiceLinkUseCase"
);

// src/use-cases/dentally-logs/get.dentally.logs.by.location.with.pagination.ts
var IGetDentallyLogsByLocationWithPaginationUseCase = Symbol(
  "GetDentallyLogsByLocationWithPaginationUseCase"
);

// src/use-cases/dentally-logs/retry.create.appointment.dentally.log.ts
var IRetryCreateAppointmentDentallyLogUseCase = Symbol(
  "RetryCreateAppointmentDentallyLogUseCase"
);

// src/use-cases/business-reviews/get.reviews.by.location.ts
var IGetReviewsByLocationUseCase = Symbol(
  "GetReviewsByLocationUseCase"
);

// src/use-cases/business-reviews/update.trust.pilot.business.url.ts
var IUpdateTrustPilotBusinessUrlUseCase = Symbol(
  "UpdateTrustPilotBusinessUrlUseCase"
);

// src/use-cases/business-reviews/update.google.map.and.place.id.ts
var IUpdateGoogleMapAndPlaceIdUseCase = Symbol(
  "UpdateGoogleMapAndPlaceIdUseCase"
);

// src/use-cases/business-reviews/delete.google.review.config.ts
var IDeleteGoogleReviewConfigUseCase = Symbol(
  "DeleteGoogleReviewConfigUseCase"
);

// src/use-cases/business-reviews/delete.trust.pilot.review.config.ts
var IDeleteTrustPilotReviewConfigUseCase = Symbol(
  "DeleteTrustPilotReviewConfigUseCase"
);

// src/use-cases/availability.alert/create.or.update.availability.alert.usecase.ts
var ICreateOrUpdateAvailabilityAlertUseCase = Symbol(
  "CreateOrUpdateAvailabilityAlertUseCase"
);

// src/use-cases/availability.alert/get-availability.alerts.config.by.locationId.usecase.ts
var IGetAvailabilityAlertsConfigByLocationIdUseCase = Symbol(
  "GetAvailabilityAlertsConfigByLocationIdUseCase"
);

// src/utils/currency.ts
var CURRENCY_SYMBOLS = {
  USD: "$",
  GBP: "\xA3",
  EUR: "\u20AC",
  JPY: "\xA5",
  CNY: "\xA5",
  INR: "\u20B9",
  AUD: "A$",
  CAD: "C$",
  CHF: "CHF",
  HKD: "HK$",
  SGD: "S$",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  NZD: "NZ$",
  MXN: "$",
  BRL: "R$",
  KRW: "\u20A9",
  THB: "\u0E3F",
  PHP: "\u20B1",
  IDR: "Rp",
  MYR: "RM",
  ZAR: "R",
  AED: "\u062F.\u0625",
  SAR: "\uFDFC",
  PLN: "z\u0142",
  CZK: "K\u010D",
  HUF: "Ft",
  TRY: "\u20BA",
  ILS: "\u20AA",
  CLP: "$",
  COP: "$",
  PEN: "S/",
  ARS: "$",
  VND: "\u20AB"
};
function getCurrencySymbol(currency) {
  const upperCurrency = String(currency || "GBP");
  return CURRENCY_SYMBOLS[upperCurrency] ?? currency;
}

export { AVAILABLE_EMAIL_VARIABLES, AVAILABLE_EMAIL_VARIABLES_TUPLE, AllCurrencyCodes, CORE_FEATURES, CURRENCY_SYMBOLS, ConnectCountriesMapping, EmailBadgeValues, EmailTemplatesKeys, IAddBusinessLocationNameUseCase, IAddBusinessUseCase, IAddCardUseCase, IAddNoteUseCase, IAddSubscriptionPlanUseCase, IAdminInitiatedPasswordResetUseCase, IApplicationSettingsRepo, IAppointmentRepository, IAvailabilityAlertsRepo, IBindPractionerSiteWithSlotLocationUseCase, IBindSquareLocationIdUseCase, IBlockUserUseCase, IBookRepository, IBookingBrandDetailRepository, IBookingPolicyRepository, IBreakRepository, IBulkUpdateServiceLinkUseCase, IBulkUpdateStatusUseCase, IBusinessRepository, IBusinessReviewRepository, IBusinessSignupUseCase, IBusinessSignupWithSubscriptionUseCase, ICardRepository, IChangeAppointmentDataTimeUseCase, IChangeAppointmentStatusUseCase, IChangeBackdateForLocationUseCase, IChangeLocationCancellationPolicy, IChangeLocationScheduleWindowUseCase, ICheckAppointmentDetailUseCase, ICheckIfAppointmentIsPaidUseCase, ICheckIfGoogleAccountConnectedUseCase, ICheckIfMicrosoftAccountConnectedUseCase, ICheckIfSlotBookedUseCase, ICheckLocationEligibilityUseCase, ICheckPaymentAccountExists, ICommunicationTimelineRepo, IConnectOrUpdateDentallyLocationTokenUseCase, IConnectStripeRefreshUrl, IConnectStripeUseCase, ICreateAppointmentPaymentIntentUseCase, ICreateAppointmentUseCase, ICreateBreakUseCase, ICreateDojoPaymentAccountUseCase, ICreateGoogleAnalyticsUseCase, ICreateGoogleTagManagerUseCase, ICreateOrUpdateAvailabilityAlertUseCase, ICreatePublicAppointmentUseCase, ICreatePublicAppointmentWithoutPaymentUseCase, ICreateServiceUseCase, ICreateSquarePaymentAccountUseCase, ICreateTimeOffUseCase, ICustomerRepository, IDashboardRepository, IDeleteAppointmentUseCase, IDeleteBreakUseCase, IDeleteBusinessUseCase, IDeleteCustomerUseCase, IDeleteGoogleCalendarEventUsingApiUseCase, IDeleteGoogleReviewConfigUseCase, IDeleteLocationUseCase, IDeleteMicrosoftEventByApiUseCase, IDeleteNoteUseCase, IDeletePaymentAccountUseCase, IDeletePaymentProviderByLocationUseCase, IDeleteServiceUseCase, IDeleteSquarePaymentAccountUseCase, IDeleteStripePaymentAccountUseCase, IDeleteSubscriptionPlanUseCase, IDeleteTimeOffUseCase, IDeleteTrustPilotReviewConfigUseCase, IDentallyLocationRepository, IDentallyLogsRepo, IDentallyServiceLinkRepo, IDisconnectCurrentLinkedPaymentAccountByLocationUseCase, IDisconnectDentallyIntegrationUseCase, IDisconnectGoogleAccountUseCase, IDisconnectMicrosoftAccountUseCase, IEditGoogleAnalyticsUseCase, IEditGoogleTagManagerUseCase, IEmailTemplatesRepo, IExcludeEventFromBlockingUseCase, IExcludeMicrosoftEventFromBlockingUseCase, IFetchAppointmentsGclidByLocationForGoogleSheetsUseCase, IFindAllPaymentLogByLocationIdWithPagination, IFindAllPaymentLogsUseCase, IFindAllRefundsByLocationWithPaginationUseCase, IFindAllSubscriptionDetailsUseCase, IFindAllSubscriptionPlansUseCase, IFindCardByUserIdUseCase, IFindDentallyLocationByIdUseCase, IFindDentallyLocationByLocationIdUseCase, IFindGoogleAnalyticsByLocationUseCase, IFindGoogleTagManagerByLocationUseCase, IFindPaymentLogByAppointmentId, IGetAllAdminsByLocationUseCase, IGetAllApplicationSettingsUseCase, IGetAllAppointmentByMonthUseCase, IGetAllAppointmentsByLocationUseCase, IGetAllAppointmentsByLocationWithPaginationUseCase, IGetAllBreaksByLocation, IGetAllBreaksByLocationUseCaseForHistory, IGetAllBusinessUseCase, IGetAllBusinessWithLocationUseCase, IGetAllCalendarEventsByStartAndEndTimeUseCase, IGetAllConnectedPaymentAccountsByLocation, IGetAllCustomerByLocationUseCase, IGetAllCustomerByLocationWithPaginationUseCase, IGetAllEmailVariables, IGetAllLiveServiceByLocationUseCase, IGetAllLocationUseCase, IGetAllLocationWithPaginationUseCase, IGetAllLocationsForDentistHubUseCase, IGetAllMicrosoftEventsByLocationAndStateEndTime, IGetAllNotesByAppointmentId, IGetAllNotesByCustomerIdUseCase, IGetAllPaymentAccountsByLocationUseCase, IGetAllPaymentTransactionsByLocationWithPagination, IGetAllServiceUseCase, IGetAllServicesByLocation, IGetAllServicesByLocationForBackOfficeUseCase, IGetAllSquareLocations, IGetAllSquarePaymentTransactionsByLocationUseCase, IGetAllSquareRefundsBySquarePaymentTransaction, IGetAllSuperAndPlatformAdminsUseCase, IGetAllTimeOffsByLocationForCalendarUseCase, IGetAllTimeOffsByLocationWithPaginationUseCase, IGetAllUsersUseCase, IGetAllWorkDaysByLocationUseCase, IGetAllWorkingDaysByLocationIncludeBreaks, IGetAllWorkingDaysHistoryByLocationUseCase, IGetApplicationFeesAllBusinessesUseCase, IGetAppointmentSummaryByBookingIdUseCase, IGetAvailabilityAlertsConfigByLocationIdUseCase, IGetAvaliableDatesForAdminUseCase, IGetAvaliableDatesUseCase, IGetAvaliableTimeSlotsUseCase, IGetAvaliableTimeSlotsV2UseCase, IGetAvaliableTimeslotsForAdminUseCase, IGetAvaliableTimeslotsForAdminV2UseCase, IGetBookingBrandDetailsByLocationUseCase, IGetBookingPoliciesByLocationUseCase, IGetBusinessByIdUseCase, IGetBusinessWithLocationBySubdomainUseCase, IGetByIdAppointmentUseCase, IGetByIdBreakUseCase, IGetByIdLocationUseCase, IGetByIdPaymentAccountUseCase, IGetByIdTimeOffUseCase, IGetCancellationPolicyUseCase, IGetCommunicationTimelineById, IGetCompleteCommunicationTimelineByAppointmentId, IGetCompleteCommunicationTimelineByCustomerId, IGetContentForBookingPageUseCase, IGetCurrentConnectedPaymentAccountUseCase, IGetCustomerByIdUseCase, IGetCustomerInformationByAppointmentIdUseCase, IGetDashboardForBusiness, IGetDashboardForLocation, IGetDentallyActivePaymentPlansByLocationIdUseCase, IGetDentallyLogsByLocationWithPaginationUseCase, IGetDentallyReasonsByLocationIdUseCase, IGetEmailPayloadValuesUseCase, IGetEmailTemplatesByLocationUseCase, IGetGoogleAccountByLocationUseCase, IGetLandingPagePlansUseCase, IGetLocationByGooglePlaceIdUseCase, IGetPastTwoMonthsNotificationByLocationUseCase, IGetPaymentBySubscriptionIdUseCase, IGetPlainLocationByIdUseCase, IGetPractionersByLocationIdUseCase, IGetProvisionalBookingUseCase, IGetReportForAllTimeAppFeeUseCase, IGetReportForAllTimeRevenue, IGetReportForBusinessUseCase, IGetReportForSmsAndEmailOfBusiness, IGetReviewsByLocationUseCase, IGetServiceByIdUseCase, IGetSitesByLocationIdUseCase, IGetSmsTemplatesByLocationUseCase, IGetUserByIdUseCase, IGoogleAccountRepo, IGoogleAnalyticsRepo, IGoogleCalendarEventsRepository, IGoogleTagManagerRepo, IHandleCalendarWebhookSyncUseCase, IHandleConnectStripeAccountStatusUseCase, IHardDeleteUserUseCase, IInitiateEmailChangeRequestUseCase, IIsGoogleTagMangerConnectedUseCase, IIsSquareConnectedUseCase, IIssueRefundUseCase, IIssueSquareRefundUseCase, IIssueStripeRefundUseCase, IListSubdomainsUseCase, ILocationRepository, ILoginUserUseCase, IMarkAsPaidAtCounterUseCase, IMarkNotificationsReadUseCase, IMicrosoftAccountRepo, IMicrosoftCalendarEventsRepository, INotesRepo, INotificationsRepository, IPaymentAccountRepository, IPaymentLinkShortenerUseCase, IPaymentLogRepository, IPaymentTransactionRepository, IPlanFeaturesRepository, IProcessStripeAppointmentPaymentUseCase, IRefreshTokenUseCase, IRefundRepository, IRegisterAdminUseCase, IRegisterBookingBrandDetailUseCase, IRegisterBookingPolicyUseCase, IRegisterCustomerUseCase, IRegisterGoogleAccountOauthUseCase, IRegisterLocationUseCase, IRegisterMicrosoftAccountUseCase, IRegisterWorkingDayUseCase, IRemoveAllGoogleEventsUseCase, IResendUserInviteUseCase, IResetPasswordForUserUseCase, IRetryCreateAppointmentDentallyLogUseCase, IRevokeTokenUseCase, ISearchAllTransactionsByLocationWithPaginationUseCase, ISearchAppointmentsWithPaginationUseCase, ISearchCustomerWithPaginationUseCase, ISearchPaymentLogByLocationIdWithPagination, ISearchRefundsByLocationWithPaginationUseCase, ISendReviewEmailsForAppointmentsUseCase, ISendUserResetEmailUseCase, IServiceRepository, ISmsTemplatesRepo, ISubscriptionChangeRepo, ISubscriptionPaymentRepo, ISubscriptionPlanRepository, ISubscriptionRepository, ISyncAppointmentDeletionFromDentallyUseCase, ISyncAppointmentStatusFromDentallyUseCase, ISyncAppointmentTimeFromDentallyUseCase, ISyncCustomerFromDentallyWithSlotUseCase, ISyncGoogleMonthsCalendarEventsUseCase, ISyncMicrosoftCalendarEventsUseCase, ISyncMicrosoftCurrentEventByWebhook, ITakePaymentPublicAppointmentUseCase, ITimeOffRepository, IToggleIntegrationStatusUseCase, IUpdateApplicationFeeByBusinessUseCase, IUpdateApplicationFeeByLocationUseCase, IUpdateApplicationSettingsUseCase, IUpdateAppointmentUseCase, IUpdateBookingBrandDetailsUseCase, IUpdateBookingPoliciesUseCase, IUpdateBreakUseCase, IUpdateBusinessUseCase, IUpdateCommunicationTimelineById, IUpdateCustomerReminderTimeUseCase, IUpdateCustomerUseCase, IUpdateDoubleBookingSettings, IUpdateEmailSenderNameUseCase, IUpdateEmailTemplateUseCase, IUpdateEmailVerificationStatus, IUpdateGoogleMapAndPlaceIdUseCase, IUpdateLeftContentForBookingPage, IUpdateLocationStatusUseCase, IUpdateLocationUseCase, IUpdateNote, IUpdatePasswordUseCase, IUpdatePatientParamtersUseCase, IUpdatePaymentAccountUseCase, IUpdatePublicAppointmentUseCase, IUpdateRefundStatusUseCase, IUpdateRightContentForPaymentPage, IUpdateServiceUseCase, IUpdateSlotsTimeFormatUseCase, IUpdateSmsTemplateByIdUseCase, IUpdateStripeRefundStatusUseCase, IUpdateSubscriptionPlanUseCase, IUpdateTermsAndConditions, IUpdateTimeOffUseCase, IUpdateTrustPilotBusinessUrlUseCase, IUpdateUserProfileUseCase, IUpdateUserStatusUseCase, IUpdateUserUseCase, IUpdateWorkingDaysUseCase, IUpgradeSubscriptionPlanUseCase, IUserRepository, IVerifyEmailChangeRequestUseCase, IVerifyInviteUseCase, IWebhookEventRepository, IWorkingDayHistoryRepo, IWorkingDayRepository, PlatFormInternalTemplatesConfigs, STARTER_FEATURES, SmsTemplateKeys, ethnicityToCodeMap, getCurrencySymbol };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map